import styled from "@emotion/styled";
import { PageLayout } from "@shared/layouts/PageLayout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import PaymentIcon from "@mui/icons-material/Payment";
import PolicyIcon from "@mui/icons-material/Policy";
import TuneIcon from "@mui/icons-material/Tune";
import { DashboardCard } from "@shared/components/DashboardCard";
import { dashboardBreadcrumbs } from "@features/Dashboard/dashboard-breadcrumbs";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  width: 100%;
  position: relative;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }
`;

export function Account() {
  return (
    <PageLayout breadcrumbs={{ current: { label: "Account" } }}>
      <Container>
        <DashboardCard
          title="Profile"
          description="Manage your personal information and preferences"
          icon={<AccountCircleOutlinedIcon fontSize="large" />}
          navigateOptions={{ path: dashboardBreadcrumbs.profile.link }}
        />

        <DashboardCard
          title="Subscription"
          description="Manage your subscription and billing information"
          icon={<PaymentIcon fontSize="large" />}
          navigateOptions={{
            path: dashboardBreadcrumbs.accountBilling.link,
          }}
        />

        <DashboardCard
          title="Integrations"
          description="Manage your connected apps and integrations"
          icon={<HubOutlinedIcon fontSize="large" />}
          navigateOptions={{ path: dashboardBreadcrumbs.integrations.link }}
        />

        <DashboardCard
          title="Settings"
          description="Define general settings"
          icon={<TuneIcon fontSize="large" />}
          navigateOptions={{
            path: dashboardBreadcrumbs.settings.link,
          }}
        />

        <DashboardCard
          title="Legal and privacy"
          description="Read our terms of service and privacy policy"
          icon={<PolicyIcon fontSize="large" />}
          navigateOptions={{ path: dashboardBreadcrumbs.terms.link }}
        />
      </Container>
    </PageLayout>
  );
}
